import { ItemTypeDetail } from '../../model/ItemTypeDetail'
import { Action } from 'typesafe-actions'

export type RowDetailsState = {
  RowDetails: { [k: string]: ItemTypeDetail }
}

export enum RowDetailsActionTypes {
  ADD_ROW_DETAILS = 'rowdetails/add-row-detail',
  CLEAR_ROW_DETAILS = 'rowdetails/clear-row-details',
  DELETE_ROW_DETAIL = 'rowDetails/delete-row-detail',
}

interface DeleteRowDetail extends Action {
  type: RowDetailsActionTypes.DELETE_ROW_DETAIL
  rowId: string
}

interface AddRowDetails extends Action {
  type: RowDetailsActionTypes.ADD_ROW_DETAILS
  rowDetails: ItemTypeDetail
}

interface ClearRowDetails extends Action {
  type: RowDetailsActionTypes.CLEAR_ROW_DETAILS
}

export type RowDetailActions = AddRowDetails | DeleteRowDetail | ClearRowDetails
